import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {PreenchFormModel, PreenchFormularioDadosModel} from '../../../../../../../model/planilhas/preench-form.model';
import {GatilhoCondicional} from '../../../../../../../model/planilhas/GatilhoCondicional';
import {ToastrService} from 'ngx-toastr';
import {DomSanitizer} from '@angular/platform-browser';
import UiSwal from '../../../../../misc/ui-swal';
import {UiModalComponent} from '../../../ui-modal/ui-modal.component';
import {CampoFormularioEstruturaModel} from '../../../../../../../model/planilhas/campo-formulario.model';
import {
    FORM_ITEM_PROPS,
    FormItemType
} from '../../../../../../../shared-pages/planilhas/manage-forms/form-creator/utils/form-checklist.models';


export class Geo {
    lat: string;
    lng: string;
    acc: string;
}

export class _ListEmittedModel {
    trigger: GatilhoCondicional;
    field: CampoFormularioEstruturaModel;
    data: PreenchFormularioDadosModel;
}

@Component({
    selector: 'ui-checklist-group',
    templateUrl: './ui-checklist-group-fields.component.html',
    styleUrls: ['./ui-checklist-group-fields.component.scss'],
    standalone: false
})
export class UiChecklistGroupFieldsComponent implements OnInit, OnChanges {
    num: number;
    interval: any;
    temPdf: boolean;
    verdadeiroFalso = true;
    loading: boolean;
    animateUnderline: boolean;
    arquivoContent: any;
    condTriggerCampoNome: string;
    selectedValor: any;
    mapCondicionais: Map<string, PreenchFormModel> = new Map();
    mapCondicionaisKeys: string[] = [];
    mapCondicionaisSavedKeys: string[] = [];
    preenchimentoCondicional: PreenchFormModel;
    underlineTimeout: any;

    triggers: GatilhoCondicional[];

    @Input() isEdit: any;
    @Input() arquivos: File[];
    @Input() preenchimento: PreenchFormModel = new PreenchFormModel();
    @Input() icon: string;
    @Input() preenchimentos: any[] = [];
    @Input() formCondicionais: PreenchFormModel[];
    @Output() formCondicionaisChange = new EventEmitter<PreenchFormModel[]>();
    @Output() preenchimentoChange = new EventEmitter<PreenchFormModel>();
    @Output() changeFormCampo = new EventEmitter<any[]>();
    @ViewChild(UiModalComponent) condicionalModal: UiModalComponent;
    private canChange: boolean;
    private isSavingCondicional = false;

    constructor(
        public toast: ToastrService,
        private sanitizer: DomSanitizer
    ) {
        this.canChange = false;
        this.arquivoContent = '';
        this.loading = true;
        this.animateUnderline = false;
    }

    ngOnInit(): void {
        if (this.preenchimento) {
            this.temPdf = false;
            this.num = 0;
        }
        this.processVerdadeiroFalso(this.preenchimento);
        this.loadConds();
        this.loading = false;
        this.triggers = this.formCondicionais.flatMap(g => g.gatilho_condicional);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.preenchimento) {
            this.processVerdadeiroFalso(this.preenchimento);
        }
        if (!this.canChange) {
            this.canChange = true;
            return;
        }
        this.loadConds();
        this.mapCondicionaisKeys = [...new Set(this.mapCondicionaisKeys)];
    }

    private mapperCondicionaisSavedKeys() {
        this.mapCondicionais.forEach((value, key) => {
            this.mapCondicionaisSavedKeys.push(key);
        });
    }

    private loadConds() {
        if (this.preenchimento) {
            this.processVerdadeiroFalso(this.preenchimento);
            this.num = 0;
            if (this.preenchimento._campo) {
                for (let i = 0; i < this.preenchimento._campo.estrutura.length; i++) {
                    const est = this.preenchimento._campo.estrutura[i];
                    if (est.tipo === 'verdadeiroFalso') {
                        this.preenchimento.dados.forEach((dado, idx) => {
                            if (dado.id === est.id) {
                                this.doesCond(dado.valor, idx, true);
                            }
                        });
                    }

                    if (est.tipo === 'gps') {
                        this.preenchimento.dados.forEach((dado, idx) => {
                            if (dado.id === est.id) {
                                if (!dado.valor) {
                                    dado.valor = new Geo();
                                }
                            }
                        });
                    }
                }
                this.mapperCondicionaisSavedKeys();
                this.loading = false;
            }
        }
    }

    animateUnderlineMethod() {
        clearTimeout(this.underlineTimeout);
        this.animateUnderline = false;

        this.animateUnderline = true;
        this.underlineTimeout = setTimeout(() => {
            this.animateUnderline = false;
        }, 2400);
    }

    private validFileByType(file: File, type: string): boolean {
        if (!file || !file.type) return false;

        const fileType = file.type.toLowerCase();

        if (type === 'pdf') {
            return fileType === 'application/pdf';
        }
        if (type === 'foto') {
            return fileType === 'image/jpeg' || fileType === 'image/png' || fileType === 'image/jpg';
        }
        if (type === 'video') {
            return fileType === 'video/mp4' || fileType === 'video/quicktime' || fileType === 'video/x-msvideo';
        }

        return false;
    }

    selectImg(i: number, files: File[], fieldType: string) {
        if (!files || files.length === 0) return;
        const fileUpload = files[0];

        if (this.validFileByType(fileUpload, fieldType)) {
            this.preenchimento.dados[i].valor = [];
            this.arquivos.push(fileUpload);
            this.preenchimento.dados[i].valor = fileUpload.name;
        } else {
            this.toast.warning('Tipo de arquivo não suportado para este campo.');
        }
    }

    selectFileCond(i: number, files: File[], preenchimento: PreenchFormModel, fieldType: string) {
        if (!files || files.length === 0) return;

        const fileUpload = files[0];

        if (this.validFileByType(fileUpload, fieldType)) {
            preenchimento.dados[i].valor = '';
            this.arquivos.push(fileUpload);
            preenchimento.dados[i].valor = fileUpload.name;
            this.canChange = false;
        } else {
            this.toast.warning('Tipo de arquivo não suportado para este campo.');
        }
    }


    doesCond(event: any, idx: number, notOpenModal?: boolean) {
        let met: string;
        const isArr = Array.isArray(event);
        if (!this.preenchimento.dados[idx]) {
            return;
        }

        met = this.getMetValue(event, idx, notOpenModal);
        this.condTriggerCampoNome = met;
        const idGrp = this.preenchimento.campo_formulario_id;
        const ordem = this.preenchimento.dados[idx].id;
        const existGatilho = this.getExistingGatilho(met, idx);
        const key = `${idGrp}_${ordem}_${met}`;
        existGatilho ? this.handleExistingGatilho(existGatilho, key, idx, isArr, notOpenModal)
            : this.handleNonExistingGatilho(idGrp, ordem, this.selectedValor, isArr);
    }

    getMetValue(event: any, idx: number, notOpenModal?: boolean) {
        if (event instanceof PointerEvent) {
            const target = event.target as HTMLInputElement;
            this.preenchimento.dados[idx].valor = target.checked;
            return target.checked.toString();
        } else if (typeof event === 'boolean') {
            this.preenchimento.dados[idx].valor = event;
            return event.toString();
        } else if (event instanceof Array) {
            if (!this.preenchimento.dados[idx].valor) {
                this.preenchimento.dados[idx].valor = [];
            }
            const met = event.filter(e => !this.preenchimento.dados[idx].valor.includes(e))[0]?.toString();
            this.preenchimento.dados[idx].valor = this.deepClone(event);
            this.selectedValor = this.preenchimento.dados[idx].valor;
            return met;
        } else {
            if (notOpenModal) {
                this.preenchimento.dados[idx].valor = event;
            } else {
                this.preenchimento.dados[idx].valor = event === this.preenchimento.dados[idx].valor ? null : event;
            }
            this.selectedValor = this.preenchimento.dados[idx].valor;
            return this.selectedValor;
        }
    }

    getExistingGatilho(met: string, idx: number) {
        const gatilhos = this.formCondicionais.flatMap(cond => cond.gatilho_condicional);
        return gatilhos?.find(gat =>
            gat.gatilho_campo_formulario_id === this.preenchimento.campo_formulario_id
            && gat.gatilho_regra.valor.toString() === met
            && gat.gatilho_campo_ordem === this.preenchimento.dados[idx].id
        );
    }

    private deepClone<T>(obj: T): T {
        return JSON.parse(JSON.stringify(obj));
    }

    handleNonExistingGatilho(idGroup: number, ordem: number, valor?: any, isArr?: boolean): void {
        this.getKeys(idGroup, ordem, valor, isArr).forEach(key => {
            const [grupoId, ord, value] = key.split('_');
            this.mapCondicionais.delete(key);
            this.mapCondicionaisSavedKeys = this.mapCondicionaisSavedKeys.filter(savedKey => savedKey !== key);
            const i = this.formCondicionais.findIndex(grp =>
                grp.gatilho_condicional.gatilho_campo_formulario_id.toString() === grupoId &&
                grp.gatilho_condicional.gatilho_campo_ordem.toString() === ord &&
                grp.gatilho_condicional.gatilho_regra.valor.toString() === value
            );
            if (i > -1) {
                this.formCondicionais[i].preenchimento_campo_id = undefined;
                this.formCondicionais[i].dados.forEach(d => d.valor = null);
            }
        });

        this.preenchimentoCondicional = new PreenchFormModel();
    }

    handleExistingGatilho(g: GatilhoCondicional, key: string, idx: number, isArr?: boolean, notModal?: boolean) {
        const [formId, campoId, valor] = key.split('_');
        const keyToDelete = this.getKeys(Number(formId), Number(campoId), valor, isArr);

        keyToDelete.forEach(_key => this.removeKeyFromSavedKeys(_key));
        if (!isArr) {
            this.mapCondicionais.delete(keyToDelete[0]);
        }

        const grupoCondicional = this.getConditionalField(g);

        if (grupoCondicional) {
            this.setupConditionalFilling(grupoCondicional, g, idx, key);
            if (!notModal) {
                this.condicionalModal.openModal();
            }
        }
    }

    private removeKeyFromSavedKeys(key: string) {
        const idxKey = this.mapCondicionaisSavedKeys.indexOf(key);
        if (idxKey > -1) {
            this.mapCondicionaisSavedKeys.splice(idxKey, 1);
        }
    }

    private getKeys(idGroup: number, ordem: number, valor?: any, isArr?: boolean): string[] {
        let keysToDelete: string[];
        if (isArr && valor) {
            const key = `${idGroup}_${ordem}_${valor}`;
            keysToDelete = this.mapCondicionaisKeys.filter(k => k === key);
        } else {
            keysToDelete = this.mapCondicionaisKeys.filter(key => {
                const [formId, campoId] = key.split('_');
                return Number(formId) === idGroup && Number(campoId) === ordem;
            });
        }

        return keysToDelete;
    }

    getConditionalField(gatilho: GatilhoCondicional) {
        return this.formCondicionais.find(grp => grp.gatilho_condicional === gatilho);
    }

    private initializeConditionalFields(preenchimento: PreenchFormModel): void {
        preenchimento?._campo?.estrutura?.forEach(estrutura => {
            const dado = preenchimento.dados?.find(
                item => item.id === estrutura.id
            );

            if (!dado) {
                return;
            }

            if (
                estrutura.tipo === FormItemType.GPS &&
                !dado.valor
            ) {
                dado.valor = new Geo();
            }
        });

        this.processVerdadeiroFalso(preenchimento);
    }

    setupConditionalFilling(campoComGatilho: any, existGatilho: any, idx: number, key: string) {
        this.preenchimentoCondicional = campoComGatilho;

        if (!this.mapCondicionais.has(key) || !this.mapCondicionaisKeys.includes(key)) {
            this.mapCondicionaisKeys.push(key);
            this.mapCondicionais.set(key, this.preenchimentoCondicional);
        } else if (this.isEdit) {
            this.preenchimentoCondicional = this.mapCondicionais.get(key);
        }
        this.preenchimentoCondicional.preenchimento_campo_id =
            this.preenchimento.id ?? this.preenchimento.dados[idx].id;
        this.initializeConditionalFields(this.preenchimentoCondicional);
    }

    isGPS(preench: PreenchFormModel) {
        return preench._campo.estrutura.some(est => est.tipo === 'gps');
    }

    private processVerdadeiroFalso(preench: PreenchFormModel): void {
        preench?._campo?.estrutura.forEach(estrutura => {
            if (estrutura.tipo === 'verdadeiroFalso') {
                preench.dados.forEach(dado => {
                    if (dado.id === estrutura.id && dado.valor === undefined) {
                        dado.valor = true;
                    }
                });
            }
        });
    }

    saveCondicional() {
        if (this.preenchimentoCondicional
            && this.checkEveryDadoHasValor(this.preenchimentoCondicional.dados,
                this.preenchimentoCondicional._campo.estrutura)
        ) {
            const formId = this.preenchimento.campo_formulario_id;
            const campoOrdem = this.preenchimentoCondicional.gatilho_condicional.gatilho_campo_ordem;

            const key = this.getKeyFromCondicionais(formId, campoOrdem, this.condTriggerCampoNome);
            if (!this.mapCondicionaisSavedKeys.includes(key)) {
                this.mapCondicionaisSavedKeys.push(key);
            }
            const atual = this.mapCondicionais.get(key);
            if (!atual || JSON.stringify(atual.dados) !== JSON.stringify(this.preenchimentoCondicional.dados)) {
                this.mapCondicionais.set(key, this.preenchimentoCondicional);
            }
            this.mapCondicionais.set(key.toString(), this.preenchimentoCondicional);
            this.isSavingCondicional = true;
            this.condicionalModal.closeModal();
            this.preenchimentoCondicional = new PreenchFormModel();
        }
    }

    private checkEveryDadoHasValor(dados: PreenchFormularioDadosModel[], estrutura: any[]): boolean {
        return dados.every(dado => {
            const estruturaItem = estrutura.find(item => item.id === dado.id);
            if (estruturaItem) {
                if (estruturaItem.opcional) {
                    return true;
                } else {
                    return dado.valor !== undefined && dado.valor !== null;
                }
            }
            return false;
        });
    }

    private getKeyFromCondicionais(idGroup: number, ordem: number, valor?: any): string {
        const key = `${idGroup}_${ordem}_${valor}`;
        return this.mapCondicionais.has(key) ? key : null;
    }

    rollbackCond() {
        if (this.isSavingCondicional) {
            this.isSavingCondicional = false;
            return;
        }
        if (!this.preenchimentoCondicional) {
            return;
        }

        const formId = this.preenchimento.campo_formulario_id;
        const campoOrdem = this.preenchimentoCondicional.gatilho_condicional.gatilho_campo_ordem;

        const key = this.getKeyFromCondicionais(formId, campoOrdem, this.condTriggerCampoNome);
        if (key) {
            const [_, campoId, valor] = key.split('_');

            // remove o campo do map apenas se ele não tiver sido preenchido
            this.preenchimento.dados.forEach(dado => {
                if (dado.id.toString() === campoId) {
                    const hasSavedValor = this.mapCondicionaisSavedKeys.includes(key);
                    if (!hasSavedValor) {
                        const valorAntes = this.selectedValor;
                        let valorAntesSemGatilho = valorAntes;
                        if (valorAntes instanceof Array) {
                            valorAntesSemGatilho = valorAntes.filter(v => v !== valor);
                        }

                        const estrutura = this.preenchimento._campo.estrutura
                            .find(est => est.id === Number(campoId));
                        if (estrutura) {
                            if (estrutura.tipo === 'verdadeiroFalso') {
                                dado.valor = true;
                            } else if (estrutura.tipo === 'listaMultipla') {
                                dado.valor = valorAntesSemGatilho ? valorAntesSemGatilho : null;
                            } else {
                                dado.valor = null;
                            }
                        }
                        this.preenchimentoCondicional.dados.forEach(d => d.valor = null);
                        this.preenchimentoCondicional.preenchimento_campo_id = null;
                        this.mapCondicionais.delete(key);
                        // remove from mapCondicionaisKeys
                        const idx = this.mapCondicionaisKeys.indexOf(key);
                        if (idx > -1) {
                            this.mapCondicionaisKeys.splice(idx, 1);
                        }
                        this.preenchimentoCondicional = new PreenchFormModel();
                    }
                }
            });
            this.condicionalModal.closeModal();
        }
        this.arquivoContent = '';
    }

    openInfo(str: string) {
        UiSwal.fire({
            title: 'Informação',
            html: `<p style="text-align: justify">${str}</p>`,
            icon: 'info',
            width: str.length > 500 ? '100em' : '40em',
            showConfirmButton: false,
            showCloseButton: true
        }).then();
    }

    async getCurrentLocation(p: PreenchFormModel, idx: number) {
        navigator.geolocation.getCurrentPosition((position) => {
            p.dados[idx].valor = {
                lat: position.coords.latitude.toString(),
                lng: position.coords.longitude.toString(),
                acc: position.coords.accuracy.toString()
            };
        }, (error) => {
            UiSwal.fire({
                title: 'Atenção',
                text: 'Não foi possível obter a localização atual. Verifique as permissões do navegador. Dessa forma' +
                    ', não será possível preencher o campo GPS.',
                icon: 'warning',
            }).then();
        });
    }

    openConditionalModal(listEmittedModel: _ListEmittedModel): void {
        this.preenchimentoCondicional =
            this.formCondicionais.find(gc =>
                Number(gc.campo_formulario_id) ===
                Number(listEmittedModel.trigger.campo_formulario_id) &&
                Number(gc.gatilho_condicional?.id) ===
                Number(listEmittedModel.trigger.id)
            );

        if (!this.preenchimentoCondicional) {
            this.toast.warning(
                'Não foi possível localizar o grupo condicional.'
            );
            return;
        }

        const idGrupo = this.preenchimento.campo_formulario_id;
        const ordem = listEmittedModel.field.id;
        const valorSelecionado = listEmittedModel.data.valor;

        const key = `${idGrupo}_${ordem}_${valorSelecionado}`;

        this.condTriggerCampoNome = valorSelecionado;

        this.preenchimentoCondicional.preenchimento_campo_id =
            this.preenchimento.id ?? ordem;

        this.initializeConditionalFields(
            this.preenchimentoCondicional
        );

        this.mapCondicionais.set(
            key,
            this.preenchimentoCondicional
        );

        if (!this.mapCondicionaisKeys.includes(key)) {
            this.mapCondicionaisKeys.push(key);
        }

        this.isSavingCondicional = false;
        this.condicionalModal.openModal();
    }

    getFileName(value: string) {
        return value.substring(value.lastIndexOf('/')).replace('/', '');
    }

    protected readonly FormItemType = FormItemType;
    protected readonly FORM_ITEM_PROPS = FORM_ITEM_PROPS;
    protected readonly console = console;
}
